import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

interface ChatHeaderProps {
  institutionName: string;
  unreadCount: number;
  onDownload?: () => void;
}

export function ChatHeader({
  institutionName,
  unreadCount,
  onDownload
}: ChatHeaderProps) {
  return (
    <div className="border-border bg-card shrink-0 border-b px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="bg-primary/10 flex h-10 w-10 items-center justify-center rounded-full">
            <span className="text-primary text-sm font-semibold">
              {institutionName.charAt(0).toUpperCase()}
            </span>
          </div>
          <div className="flex-1">
            <h2 className="text-base font-semibold">{institutionName}</h2>
            {unreadCount > 0 && (
              <p className="text-muted-foreground text-xs">
                {unreadCount} new message{unreadCount === 1 ? '' : 's'}
              </p>
            )}
          </div>
        </div>
        {onDownload && (
          <Button
            variant="ghost"
            size="icon-sm"
            onClick={onDownload}
            title="Download correspondence"
          >
            <Download className="h-4 w-4" />
            <span className="sr-only">Download correspondence</span>
          </Button>
        )}
      </div>
    </div>
  );
}
